// extracted by mini-css-extract-plugin
export default {"container":"ProjectNameWidget_container__zR2VQ","name":"ProjectNameWidget_name__iUg80","vendor":"ProjectNameWidget_vendor__Rwpdn","input":"ProjectNameWidget_input__je8sc"};